module.exports = __webpack_public_path__ + "static/media/KITE-BUSD.7bc289ba.png";